var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { REBILLY_PUBLICKEYS, REBILLY_URLS } from './api';
export const createPaymentToken = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { sandbox } = params;
    const options = {
        headers: {
            Authorization: sandbox ? REBILLY_PUBLICKEYS.local : REBILLY_PUBLICKEYS.prod,
            'Content-Type': 'application/json',
        },
    };
    try {
        const response = yield axios.post(`${sandbox ? REBILLY_URLS.local : REBILLY_URLS.prod}/tokens`, params, options);
        const responseData = response.data;
        if (response.status !== 200) {
            if (responseData.invalidFields) {
                const invalidFieldMessage = responseData.invalidFields.map((field) => {
                    return field.message;
                });
                responseData.message = invalidFieldMessage.join('/n');
                throw Error(responseData.message);
            }
        }
        return responseData.id;
    }
    catch (ex) {
        if (ex.response) {
            console.error(`createPaymentToken: ${JSON.stringify(ex.response.data)}`);
        }
        throw ex;
    }
});
